import Meta from '@/components/common/Meta'

import MovingAndStorageDiscountsPage from '@/v2/components/pages/landing-pages/moving-and-storage-discounts-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import {
  faqSectionContent,
  metaImages,
  ogImages
} from '@/v2/constants/pages/landing-pages/moving-and-storage-discounts-page'

interface MovingAndStorageDiscountsPageProps {}

const Page: React.FC<MovingAndStorageDiscountsPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.moving_and_storage_discounts.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.moving_and_storage_discounts?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.moving_and_storage_discounts?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <MovingAndStorageDiscountsPage />
    </>
  )
}

export default Page
